import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/dobovoActions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch, showImportApartmentsToastr } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchDobovoApartments = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.DOBOVO_APARTMENTS_FETCH_REQUEST })

    const { auth } = getState()

    securedFetch(urlParams(urls.dobovoApartmentsFind, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.dobovo_fetchApartmentsSuccess(getParser(urls.dobovoApartments)(json))))
        .catch(
            handleError(
                dispatch,
                actions.dobovo_fetchApartmentsFailure,
                'Что-то пошло не так!',
                'При получении апартаментов произошла ошибка'
            )
        )
}

/** @thunk **/
export const postDobovoApartment = category => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(category)
    }

    const { auth } = getState()

    securedFetch(urls.dobovoApartments, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.dobovo_saveApartmentsSuccess(json)))
        .then(() => toastr.success('Апартаменты успешно сохранены'))
        .catch(
            handleError(
                dispatch,
                actions.dobovo_saveApartmentsFailure,
                'Что-то пошло не так!',
                'При сохранении апартаментов произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteDobovoApartment = remoteId => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.dobovoApartmentSelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.dobovo_deleteApartmentSuccess(remoteId)))
        .then(() => toastr.success('Апартаменты удалены'))
        .catch(
            handleError(
                dispatch,
                actions.dobovo_deleteApartmentFailure,
                'Что-то пошло не так!',
                'При удалении апартаментов произошла ошибка'
            )
        )
}

/** @thunk **/
export const importDobovoApartments = () => (dispatch, getState) => {
    const { dobovoCurrentOrganization } = getState()

    const { auth } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ dobovoOrganizationId: dobovoCurrentOrganization })
    }

    securedFetch(urls.reloadApartmentsFromDobovo, auth, opts)
        .then(handleResponse)
        .then(showImportApartmentsToastr)
        .then(json =>
            dispatch(actions.dobovo_importApartmentsSuccess(getParser(urls.reloadApartmentsFromDobovo)(json)))
        )
        .catch(
            handleError(
                dispatch,
                actions.dobovo_importApartmentsFailure,
                'Что-то пошло не так!',
                'При импорте апартаментов произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/dobovoApi/dobovoApartments.js